import { render, staticRenderFns } from "./ordering.vue?vue&type=template&id=be6b85aa&scoped=true"
import script from "./ordering.vue?vue&type=script&lang=tsx"
export * from "./ordering.vue?vue&type=script&lang=tsx"
import style0 from "./ordering.vue?vue&type=style&index=0&id=be6b85aa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6b85aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/frontend_page_elephant/frontend_page_elephant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be6b85aa')) {
      api.createRecord('be6b85aa', component.options)
    } else {
      api.reload('be6b85aa', component.options)
    }
    module.hot.accept("./ordering.vue?vue&type=template&id=be6b85aa&scoped=true", function () {
      api.rerender('be6b85aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ops/ordering.vue"
export default component.exports